export function normalizeRateCategories (data) {
  if (!Array.isArray(data.rateList)) return data

  const hasSports = data.rateList.some(item => item.category === 'sports')
  return {
    ...data,
    rateList: data.rateList
      .filter(item => item.category !== 'sport' || !hasSports)
      .map(item => item.category === 'sport' ? { ...item, category: 'sports' } : item)
  }
}
